import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../components/Hero";
import { EditorialMarquee } from "../components/Marquee";
import { CallStrip } from "../components/CallStrip";
import { ApartmentGrid } from "../components/ApartmentGrid";
import { HotelsSection } from "../components/HotelsSection";
import { VillasSection } from "../components/VillasSection";
import { RentalSection } from "../components/RentalSection";
import { Manifesto } from "../components/Manifesto";
import { ContactSection } from "../components/ContactSection";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, [location.hash]);

  return (
    <main data-testid="home-page">
      <Hero />
      <EditorialMarquee />
      <CallStrip />
      <ApartmentGrid />
      <HotelsSection />
      <VillasSection />
      <RentalSection
        id="vozila"
        titleKey="rental.vehicles"
        light
        tabs={[
          { labelKey: "rental.motoAll", images: ["/images/vozila/t5-1.webp", "/images/vozila/box-2.png", "/images/vozila/t5-2.png", "/images/vozila/box-1.png", "/images/vozila/t5-3.webp", "/images/vozila/box-3.webp", "/images/vozila/t5-4.webp", "/images/vozila/box-4.webp", "/images/vozila/t5-5.jpg", "/images/vozila/t5-6.webp", "/images/vozila/t5-7.webp", "/images/vozila/t5-8.webp"] },
          { label: "Forthing T5 Evo", images: ["/images/vozila/t5-1.webp", "/images/vozila/t5-2.png", "/images/vozila/t5-3.webp", "/images/vozila/t5-4.webp", "/images/vozila/t5-5.jpg", "/images/vozila/t5-6.webp", "/images/vozila/t5-7.webp", "/images/vozila/t5-8.webp"] },
          { label: "Dongfeng Box", images: ["/images/vozila/box-2.png", "/images/vozila/box-1.png", "/images/vozila/box-3.webp", "/images/vozila/box-4.webp"] },
        ]}
      />
      <RentalSection
        id="motori"
        titleKey="rental.motorcycles"
        tabs={[
          { labelKey: "rental.motoAll", images: ["/images/motori/motor-1.jpg", "/images/motori/motor-2.jpg", "/images/motori/motor-3.jpg", "/images/motori/motor-4.jpg", "/images/motori/motor-5.jpg", "/images/motori/motor-6.jpg", "/images/motori/motor-7.jpg", "/images/motori/motor-8.jpg"] },
          { label: "Kawasaki", images: ["/images/motori/motor-1.jpg", "/images/motori/motor-2.jpg", "/images/motori/motor-3.jpg", "/images/motori/motor-4.jpg", "/images/motori/motor-8.jpg"] },
          { label: "Yamaha", images: ["/images/motori/motor-7.jpg", "/images/motori/motor-5.jpg", "/images/motori/motor-6.jpg"] },
        ]}
      />
      <RentalSection id="velosipedi" titleKey="rental.bicycles" light />
      <RentalSection id="ketering" titleKey="rental.catering" images={["/images/vila-enigma/vila-26.webp", "/images/events/event-3.jpg", "/images/events/event-4.jpg", "/images/events/event-1.webp", "/images/events/event-2.webp"]} />
      <RentalSection id="turi" titleKey="rental.tours" light />
      <Manifesto />
      <ContactSection />
    </main>
  );
}
